
// src/web/components/user-profile-panel.jsx

import React from 'react'
import connect from '../../connects/user-profile-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import theme from './themes/flat-card.css'
import {
  Input,
} from 'react-toolbox/lib/input'
// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import FileUploadButton from './file-upload-button.jsx'
import RichTextEditor from './rich-text-editor.jsx'
import {
  linkUI 
} from '../../helpers/form-validator'
import AvatarEditor from 'react-avatar-editor'
import _ from 'lodash'
import Loading from './loading.jsx'
import successButtonTheme from './themes/success-button.css'
import ConfirmDialog from './confirm-dialog.jsx'
import DatePicker from './date-picker.jsx'
import FontIcon from 'react-toolbox/lib/font_icon'
import moment from 'moment'
import Dropdown from 'react-toolbox/lib/dropdown'

function calcCrop(avatar) {
  // Check if avatar and necessary nested properties exist
  if (!avatar || !avatar.state || !avatar.state.image || !avatar.state.image.resource) {
    return undefined;
  }

  const rect = avatar.getCroppingRect()
  const width = avatar.state.image.resource.width
  const height = avatar.state.image.resource.height
  //console.log(`rect x:${rect.x} y:${rect.y} w:${rect.width} h:${rect.height}, image: w:${width} h:${height}`)
  //console.log(`calc x:${width * rect.x} y:${height * rect.y} w:${width * rect.width} h:${height * rect.height}`)

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height,
  }
}

class UserProfilePanel extends React.Component {
  state = { scale: 1.5, importConfirm: false }

  render() {
    const {
      t,
      ui,
      isProfileUpdating,
      user,
      updateUI,
      uploadFile,
      uploadedFile,
      validateAndSubmit,
      isUploading,
      importUserProfileTemplate,
      userProfileTemplate,
      clearUserProfileTemplate,
    } = this.props

    let departmentDropDownList = [{ value: 0, label: t('label:部署を選択') }];

    if (user && user.department_list) {
      departmentDropDownList = [{ value: 0, label: t(user.department_list.length > 0 ? 'label:部署を選択' : 'label:部署が設定されていません') },
        ...user.department_list.map(item => ({ value: item.id, label: item.name }))];
    }

    return (
      <Card theme={theme}>
        <form onSubmit={(e) => validateAndSubmit(this.props, calcCrop(this.refs.avatar), e)}>
          <CardText>
            <normal><strong>{t('label:ユーザ名')}</strong></normal>
            <Input name="userName" required
              label={t('label:ユーザ名')}
              value={ui.name}
              icon='person'
              error={ui.nameError && t('error:ユーザ名を入力してください')}
              onChange={linkUI(this, 'name')} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:アイコン画像')}</strong></normal><br />
            {!uploadedFile && !isUploading &&
              <div>
                <img style={{ width: 100, height: 100, borderRadius: '50%' }} src={user.icon_image.thumb_url} />
              </div>
            }
            {uploadedFile && !isUploading && uploadedFile.file &&
              <div style={{ display: 'flex', flexDirection: 'column', width: 210 }}>
                <AvatarEditor ref="avatar"
                    image={uploadedFile.file.thumb_url}
                    width={200}
                    height={200}
                    border={5}
                    scale={this.state.scale}
                    style={{ cursor: 'move' }} />
                <Slider
                    min={1}
                    max={5}
                    step={0.05}
                    tooltip={false}
                    value={this.state.scale}
                    onChange={(value)=> this.setState({ scale: value })} />
              </div>
            }
            {isUploading &&
              <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' }}>
                <ProgressBar type='circular' multicolor mode='indeterminate' />
              </div>
            }
            <FileUploadButton raised
              icon='add_a_photo'
              label='ファイルを選択'
              single
              onChange={(file)=> uploadFile(this.props, file)} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:社員番号')}</strong></normal>
            <Input name="employmentNumber"
              label={t('label:社員番号')}
              value={ui.employmentNumber}
              icon='badge'
              onChange={linkUI(this, 'employmentNumber')} />
          </CardText>
          <CardText>
            <normal><strong>{t('label:部署')}</strong></normal>
            <div className={theme.departmentContainer}>
              <FontIcon value='school' className={theme.fontIcon} />
              <Dropdown auto
                label={t('label:部署')}
                className={theme.department_dropdown}
                source={departmentDropDownList}
                value={ui.department_id}
                onChange={(value)=> updateUI({ department_id: value })}
              />
            </div>
          </CardText>
          <CardText>
            <normal><strong>{t('label:誕生日')}</strong></normal>
            <div className={theme.datePickerContainer}>
              <FontIcon value='event_note' className={theme.fontIcon} />
              {!ui.isUpdateBirthday && 
                <Button theme={theme} raised neutral ripple
                  icon={"add"}
                  onClick={()=> updateUI({ isUpdateBirthday: true })}
                  label={t('label:誕生日を追加')}/>
              }
              {ui.isUpdateBirthday &&
                <div style={{ display: 'flex' }}>
                  <DatePicker
                    label={t('label:誕生日')}
                    value={ui.birthday.toDate()}
                    onChange={(date)=> updateUI({ birthday: moment(date) })} />
                  <Button theme={theme} raised neutral ripple
                    className={theme.cancelBirthdayBtn}
                    icon={"close"}
                    onClick={()=> updateUI({ isUpdateBirthday: false })}
                    label={t('label:削除')}/>
                </div>
              }
            </div>
          </CardText>

          <CardText>
            <normal><strong>{t('label:自己紹介')}</strong></normal><br />
            <RichTextEditor
                userDescription={true}
                value={user && user.description}
                userProfileTemplate={userProfileTemplate && userProfileTemplate}
                importUserProfileTemplate={importUserProfileTemplate}
                clearUserProfileTemplate={clearUserProfileTemplate}
                onEditorInitialized={(handlers) => {
                  updateUI({ handlers })
                  user.description && setTimeout(()=> handlers.insertValue(user.description), 0)
                }} />
          </CardText>
          <CardActions>
            <Button raised primary
              type="submit"
              disabled={isProfileUpdating}
              style={{ width: '100%' }}
              label={t('label:更新')} />
          </CardActions>
        </form>
      </Card>
    )
  }
}

export const RawUserProfilePanel = UserProfilePanel
export default connect(UserProfilePanel)



// WEBPACK FOOTER //
// ./src/web/components/user-profile-panel.jsx